import { TransactionEventTypeMock } from 'modules/clients/types/client.enum';
import {
  TransactionDetailResponseMock,
  TransactionModelMock
} from 'modules/clients/types/client.interfaces';

const mockTransactions: TransactionModelMock[] = [
  {
    transactionId: 10,
    transactionEventType: TransactionEventTypeMock.interest,
    transactionDate: new Date('2025-08-15'),
    investmentOption: 'Allan Gray Money Market - A (Parking)',
    amountTarget: 120.45
  },
  {
    transactionId: 11,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-08-20'),
    investmentOption: 'Coronation Balanced Defensive - P',
    amountTarget: 50.25
  },
  {
    transactionId: 12,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-08-22'),
    investmentOption: 'NinetyOne Managed - H',
    amountTarget: 75.0
  },
  {
    transactionId: 13,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-01'),
    investmentOption: 'Allan Gray Stable - C',
    amountTarget: 62.1
  },
  {
    transactionId: 14,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-05'),
    investmentOption: 'Allan Gray Money Market - A (Parking)',
    amountTarget: 48.5
  },
  {
    transactionId: 15,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-10'),
    investmentOption: 'Coronation Balanced Defensive - P',
    amountTarget: 55.75
  },
  {
    transactionId: 16,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-12'),
    investmentOption: 'NinetyOne Managed - H',
    amountTarget: 70.0
  },
  {
    transactionId: 17,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-15'),
    investmentOption: 'Allan Gray Stable - C',
    amountTarget: 65.3
  },
  {
    transactionId: 18,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-18'),
    investmentOption: 'Allan Gray Money Market - A (Parking)',
    amountTarget: 52.8
  },
  {
    transactionId: 19,
    transactionEventType: TransactionEventTypeMock.dividendDeclaration,
    transactionDate: new Date('2025-09-20'),
    investmentOption: 'Coronation Balanced Defensive - P',
    amountTarget: 49.9
  },
  {
    transactionId: 20,
    transactionEventType: TransactionEventTypeMock.interestDeclaration,
    transactionDate: new Date('2025-09-22'),
    investmentOption: 'NinetyOne Managed - H',
    amountTarget: 80.25
  },
  {
    transactionId: 21,
    transactionEventType: TransactionEventTypeMock.interestDeclaration,
    transactionDate: new Date('2025-09-24'),
    investmentOption: 'Allan Gray Stable - C',
    amountTarget: 60.0
  },
  {
    transactionId: 22,
    transactionEventType: TransactionEventTypeMock.interestDeclaration,
    transactionDate: new Date('2025-09-26'),
    investmentOption: 'Allan Gray Money Market - A (Parking)',
    amountTarget: 75.5
  },
  {
    transactionId: 23,
    transactionEventType: TransactionEventTypeMock.interestDeclaration,
    transactionDate: new Date('2025-09-28'),
    investmentOption: 'Coronation Balanced Defensive - P',
    amountTarget: 65.2
  },
  {
    transactionId: 24,
    transactionEventType: TransactionEventTypeMock.interestDeclaration,
    transactionDate: new Date('2025-10-01'),
    investmentOption: 'NinetyOne Managed - H',
    amountTarget: 70.4
  },
  {
    transactionId: 25,
    transactionEventType: TransactionEventTypeMock.fees,
    transactionDate: new Date('2025-10-03'),
    investmentOption: 'Administration fee',
    amountTarget: 12.5
  },
  {
    transactionId: 26,
    transactionEventType: TransactionEventTypeMock.fees,
    transactionDate: new Date('2025-10-05'),
    investmentOption: 'Financial intermediary fee',
    amountSource: 8.25
  },
  {
    transactionId: 27,
    transactionEventType: TransactionEventTypeMock.fees,
    transactionDate: new Date('2025-10-07'),
    investmentOption: 'VAT',
    amountSource: 5.15,
    amountTarget: 5.15
  },
  {
    transactionId: 28,
    transactionEventType: TransactionEventTypeMock.fees,
    transactionDate: new Date('2025-10-09'),
    investmentOption: 'Other fee',
    amountSource: 10.0,
    amountTarget: 10.0
  }
];

export const mockTransactionDetailResponse: TransactionDetailResponseMock[] = [
  {
    investmentName: 'Personal Portfolio Living Annuity',
    investmentNumber: 63845,
    investmentInceptionDate: new Date('2018-11-03'),
    transactions: mockTransactions
  },
  {
    investmentName: 'Personal Portfolio Retirement Annuity',
    investmentNumber: 15268,
    investmentInceptionDate: new Date('2017-02-18'),
    transactions: mockTransactions
  },
  {
    investmentName: 'IWA Cautious Portfolio (Comp.)',
    investmentNumber: 17845,
    investmentInceptionDate: new Date('2019-07-29'),
    transactions: mockTransactions
  },
  {
    investmentName: 'Personal Portfolio Living Annuity - (Value Plus Range)',
    investmentNumber: 75025,
    investmentInceptionDate: new Date('2021-01-12'),
    transactions: mockTransactions
  }
];
